import React from "react";
import { Link } from "react-router-dom";
import { IconMap } from "../sidebar/Sidebar";
import { menuItems } from "../menu/menuItems";

export function BottomNavigation({ active = "dashboard" }) {

  const mobileItems = menuItems.filter(
    item => item.mobile === true
  );

  return (
    <nav className="
      fixed
      bottom-0
      left-0
      right-0
      bg-white
      border-t
      border-border
      z-40
      flex
      justify-around
      py-2
      md:hidden
    ">

      {mobileItems.map((item) => (

        <Link
          key={item.value}
          to={item.path}
          className={`
            flex
            flex-col
            items-center
            text-xs
            ${
              active === item.value
              ? "text-primary"
              : "text-text-secondary"
            }
          `}
        >

          {IconMap[item.value]}

          <span>
            {item.label}
          </span>

        </Link>

      ))}

    </nav>
  );
}